/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q2Inputs */

const en_formatter_faq_q2 = /** @type {(inputs: Formatter_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does formatting change my JSON data?`)
};

const ko_formatter_faq_q2 = /** @type {(inputs: Formatter_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포맷하면 JSON 데이터가 변경되나요?`)
};

const ja_formatter_faq_q2 = /** @type {(inputs: Formatter_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーマットするとJSONデータは変わりますか？`)
};

/**
* | output |
* | --- |
* | "Does formatting change my JSON data?" |
*
* @param {Formatter_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q2 = /** @type {((inputs?: Formatter_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q2(inputs)
	if (locale === "ko") return ko_formatter_faq_q2(inputs)
	return ja_formatter_faq_q2(inputs)
});